import { useAppSelector } from '../../store';
import { selectPaymentIsCryptoPay } from 'store/payments';
import { WalletModalContentCryptoPay } from './WalletModalContentCryptoPay';
import { WalletModalContent } from './WalletModalContent';

export const WALLET_MODAL_KEY = 'WALLET_MODAL_KEY';

export const WalletModal = () => {
  const isCryptoPay = useAppSelector(selectPaymentIsCryptoPay);

  // TODO: вынести общий функционал
  return isCryptoPay ? <WalletModalContentCryptoPay /> : <WalletModalContent />;
};
